import { Box, Typography } from "@mui/material";
import { toTitleCase } from "../../../../Helper/Formatters/TextFormatter";

export default function BatteryOverviewKeyMetric({keyMetric, value, isAlert, width = '165px'}) {
    const valueText = [null, undefined, ''].includes(value) ? '-' : toTitleCase(value.toString());
    const valueUnit = valueText !== '-' ? keyMetric.unit : '';
    return (
        <Box sx={{width, backgroundColor: isAlert ? '#FFF1F1' : '#FAFAFA', py: 1.5, px: 2.5, borderRadius: '8px'}}>
            <Typography variant="fw400s14lh24c686868">{keyMetric.label}</Typography>
            <Box sx={{display: 'flex', alignItems: 'center'}}>
                <Typography variant="fw400s16lh28c2E2E2E" sx={{color: isAlert ? '#B50500' : '#2E2E2E'}}>{valueText}&nbsp;{valueUnit}</Typography>
            </Box>
        </Box>
    )
}
